module.exports = "<link href=\"https://cdn.materialdesignicons.com/2.1.19/css/materialdesignicons.min.css\" rel=\"stylesheet\" />\r\n<div class=\"app-container\">\r\n  <mat-progress-bar color=\"accent\" mode=\"indeterminate\" *ngIf=\"isLoading\" style=\"position: fixed; z-index: 9999;\"></mat-progress-bar>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main